// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-attribute-attrEdits-AttrSelectValuesModal-AttrSelectValuesModal-module__content--H7oaU {
  height: calc(80vh - 100px);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.src-business-attribute-attrEdits-AttrSelectValuesModal-AttrSelectValuesModal-module__inner--pReAT {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-business-attribute-attrEdits-AttrSelectValuesModal-AttrSelectValuesModal-module__table--_qE03 {
  flex: 1;
  overflow: hidden;
}
/*# sourceMappingURL=AttrSelectValuesModal.module.css.map */`, "",{"version":3,"sources":["webpack://./AttrSelectValuesModal.module.less","webpack://./src/business/attribute/attrEdits/AttrSelectValuesModal/AttrSelectValuesModal.module.less"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACCF;ADEA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ACAF;ADEA;EACE,OAAA;EACA,gBAAA;ACAF;AACA,2DAA2D","sourcesContent":[".content {\n  height: calc(80vh - 100px);\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.inner {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.table {\n  flex: 1;\n  overflow: hidden;\n}\n",".content {\n  height: calc(80vh - 100px);\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.inner {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.table {\n  flex: 1;\n  overflow: hidden;\n}\n/*# sourceMappingURL=AttrSelectValuesModal.module.css.map */"],"sourceRoot":""}]);
// Exports
export var content = `src-business-attribute-attrEdits-AttrSelectValuesModal-AttrSelectValuesModal-module__content--H7oaU`;
export var inner = `src-business-attribute-attrEdits-AttrSelectValuesModal-AttrSelectValuesModal-module__inner--pReAT`;
export var table = `src-business-attribute-attrEdits-AttrSelectValuesModal-AttrSelectValuesModal-module__table--_qE03`;
export default ___CSS_LOADER_EXPORT___;
